<form [formGroup]="form.formGroup">
  <div class="flex flex-col space-y-2">

    <app-general-epp
      [formControlName]="form.formControlNames.generalEpp"
      [currentString]="currentString"
      [userUnits]="userUnits"
      [loadCaseIndex]="loadCaseIndex"
      [hideDeterioratedMudOption]="true"
    ></app-general-epp>

    <p class="text-sm">
      Mud Weight: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      {{ currentString?.annularFluid.state.nominalDensity.toFixed(2) }} {{ densityLabel }}
    </p>

    <p class="text-sm">
      Top Of Cement: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      {{ currentString?.topOfCementMd.toFixed(2) }} {{ userUnits.longLengths }}
    </p>

    @if (this.currentString?.hasCement || currentString.topOfCementMd !== currentString.shoeMd) {
      <p class="text-sm">
        Lead Slurry Density: &nbsp;&nbsp;
        {{ cement?.leadSlurryDensity.toFixed(2) }} {{ densityLabel }}
      </p>
    }

    @if (!this.currentString?.hasCement && currentString.topOfCementMd == currentString.shoeMd) {
      <p class="text-sm">
        Uncemented String
      </p>
    }

    @if (cement?.tailSlurryLength > 0) {
      <p class="text-sm">
        Tail Slurry Density: &nbsp; &nbsp; &nbsp;
        {{ cement?.tailSlurryDensity.toFixed(2) }} {{ densityLabel}}
      </p>
    }

    @if (cement?.tailSlurryLength > 0) {
      <p class="text-sm">
        Tail Slurry Length: &nbsp; &nbsp; &nbsp;
        {{ cement?.tailSlurryLength.toFixed(2) }} {{ userUnits.longLengths }} 
      </p>
    }
    
  </div>
</form>
